import styled from 'styled-components';
import * as variables from './../../assets/css/variables';

export const Content = styled.div`
  margin-top: 2.9035714285714285rem;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  max-width: ${variables.MAX_WIDTH};
  
  h1, h6 {
    margin: 0;
    padding: 0;
  }
  
  h1 {
    font-size: 2.2857142857142856rem;
  }
  
  h6 {
    font-weight: normal;
    font-size: 1.2857142857142858rem;
  }
  
  hgroup {
    margin-bottom: 3rem;
  }
  
  @media (max-width: ${variables.TABLET}) {
      margin-left: ${variables.SPACING};
      margin-right: ${variables.SPACING};
      
      h1 {
        font-size: 1.1428571428571428rem;
      }
      
      h6 {
        font-weight: normal;
        font-size: 1rem;
      }
  }
`;

export const Carrousel = styled.section`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: .5rem;
  justify-content: space-evenly;
  
  > article {
      flex: 0 0 auto;
      
      :not(:last-child) {
        margin-right: 1.07rem;
      }
  }
  
  @media (max-width: ${variables.TABLET}) {
      justify-content: start;
  }
`;